import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "./style.css";
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import PatientReviews from '../../PatientReview.js';
import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
// import Counter from '../../../NumCounter.js'
import Counter from '../../../NumCounter.js'
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Nasal Polyp Removal Surgery in Delhi, India| Treatment & Cost</title>
            <meta name="description" content="Get expert nasal polyp removal surgery in Delhi, India, at an affordable cost. Advanced treatment by skilled ENT specialists ensures painless recovery and better breathing." />
            <meta name="keywords" content="Nasal Polyp Removal Surgery, Nasal Polyp Removal Surgery Cost, Nasal Polyp Surgery in Delhi, Endoscopic Nasal Polyp Removal, Nasal Polyp Treatment in Delhi NCR, Nasal Polyp Surgery Cost in India, Best ENT Doctor for Nasal Polyps, Nasal Polyp Removal with Insurance, Affordable Nasal Polyp Surgery Delhi" />
            <link rel="canonical" href="https://entdelhi.com/nasal-polyp-removal/" />
            <meta property="og:title" content="Nasal Polyp Removal Surgery in Delhi, India| Treatment & Cost" />
            <meta property="og:description" content="Get expert nasal polyp removal surgery in Delhi, India, at an affordable cost. Advanced treatment by skilled ENT specialists ensures painless recovery and better breathing." />
            <meta name="robots" content="index, followjdhfuiefp" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
         <Counter/>
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}
